<div class="fc-dropdown">
    <ng-content></ng-content>
</div>
